import type { FC } from 'react';
import { Icon } from '../../../ui/icon/Icon';
import { IconStyles } from '../../../ui/icon/Icon.types';
import { Icons } from '../../../ui/icon/icons/material';
import styles from './HelpCasePanel.module.scss';
import labels from '../../../data/labels';

export interface HelpCaseCollapsedTriggerProps {
    onExpand: () => void;
}

const HelpCaseCollapsedTrigger: FC<HelpCaseCollapsedTriggerProps> = ({ onExpand }) => (
    <div className={styles['collapsed-trigger-wrapper']}>
        <button
            type="button"
            aria-label={labels.help}
            className={styles['collapsed-trigger']}
            onClick={onExpand}
        >
            <div className={styles['collapsed-trigger-content']}>
                <span className={styles['collapsed-icon']}>
                    <Icon.Base title={labels.help} iconName={Icons.help} iconStyle={IconStyles.filled} className={styles.icon} />
                </span>
                <span className={styles['collapsed-text']}>{labels.HelpCasePanelTitle}</span>
            </div>
        </button>
    </div>
);

export default HelpCaseCollapsedTrigger;
